import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@Component({
  selector: 'app-success-user-group',
  templateUrl: './success-user-group.component.html',
  styleUrls: ['./success-user-group.component.scss'],
})
export class SuccessUserGroupComponent implements AfterViewInit {
  @Input() dialogRef?: any; //close event of parent component
  @Input() isEditMode!: boolean;
  @Input() stepper!: number;
  @Output() stepperChange = new EventEmitter<number>();

  readonly LANG_CONST = LANG_CONST;
  constructor(private localizationService: LocalizationService) {}

  ngAfterViewInit(): void {
    this.localizationService.setupLocalization();
    this.setTimmer();
  }

  setTimmer() {
    setTimeout(() => {
      this.stepperChange.emit(1);
    }, 2000);
  }
}
